module.exports = __webpack_public_path__ + "static/img/liznable.bdbfba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/liznable.png
// module id = Ldr6
// module chunks = 14